import { LMS_CONSTANTS } from "@ipru-common/constants/SiteConstants";
import { OPTION_VALUES, PaymentOptionName } from "@ipru-common/constants/InputValues";
import CryptoJS from "crypto-js";
import _ from "lodash";
import GlobalStore from "@ipru-common/store/GlobalStore";
import CommonKeys from "./CommonUserInput";
import { mapDataToSuitabilityData } from "@ipru-common/components/CommonComponents/SuitabilityCalModal/SuitabilityMapper";
import { calculatePayoutDetails, getCiTerm } from "../QuoteCommonFunctions";
import { calculateAnnualPremium, calculateSAMultiple } from "@ipru-common/utils/SmartKidQuote/commonUtils";
import { convertToWords, getSelectedFunds, readQueryParams } from "@ipru-common/utils/CommonFunctions";
import { getCurrentTimeStamp, getWOPOption, trueFalse } from "../SavingsAppForm/SavingAppFormsUtils";
import { getAge } from "@ipru-common/libs/ValidationSchemas/CustomRules";
import QuoteFormStore from "@ipru-common/store/QuoteFormStore";

const getGiftProUserInput = () => {
  const {
    appFormData,
    quoteFormData,
    calculatorFormData,
    savingForm,
    existingCustomer,
    currentPageStep,
    suitabilityMatrix,
  } = GlobalStore.getSnapshot();

  const suitabilityData = mapDataToSuitabilityData(calculatorFormData, quoteFormData);
  const queryParams = readQueryParams();
  const QuoteFormValues = QuoteFormStore.getQuoteFormData();

  const UID = queryParams.get("UID") || "480";
  const urlParams = new URLSearchParams(window?.location?.search);
  const params = Object.fromEntries(urlParams?.entries());
  const { isWopSelected, wopOption } = getWOPOption(quoteFormData?.selectedRiders);
  const RiderOptionAdded =
    quoteFormData?.selectedRiders && quoteFormData?.selectedRiders.length > 0
      ? OPTION_VALUES.TRUE_STRING
      : OPTION_VALUES.FALSE_STRING;

  const { lumpsumPercentage } = calculatePayoutDetails(
    quoteFormData?.payoutType,
    quoteFormData?.monthlyIncomePayoutYears,
    quoteFormData?.SA,
    quoteFormData?.monthlyIncomeAmt,
    quoteFormData?.lumpSumAndIncomeYears,
    quoteFormData?.lumpSumIncomeSingleInst,
    quoteFormData?.income_duration
  );
  const annualPremium = calculateAnnualPremium(quoteFormData?.invest, quoteFormData?.paymentFrequency);
  let giftProInput = {
    usetobacco: calculatorFormData?.tobacco,
    citerm:
      getCiTerm(quoteFormData?.paymentOption, calculatorFormData?.age, quoteFormData?.ppt, quoteFormData?.term) || 0,
    adbterm: _.min([quoteFormData?.term, 80 - parseInt(calculatorFormData?.age)]) || 0,
    premiumpaymentoption: PaymentOptionName[quoteFormData?.paymentOption],
    sumassured: quoteFormData?.SA,
    accidental_death_benefit: quoteFormData?.ADB_SA,
    critical_illness_benefit: quoteFormData?.CI_SA,
    payoutoptions: LMS_CONSTANTS[quoteFormData?.payoutType],
    paymentfrequency: quoteFormData?.paymentFrequency,
    plan: `${quoteFormData?.planType?.charAt(0).toUpperCase()}${quoteFormData?.planType?.slice(1)}`,
    lumpsumper: lumpsumPercentage,
    premium: quoteFormData?.invest + +quoteFormData?.riderPremium,
    monthly_premium: quoteFormData?.paymentFrequency === OPTION_VALUES.PAYMENT_TENURE.MONTHLY,
    trai_flag: calculatorFormData?.trai_flag ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    annual_income: calculatorFormData?.yr_income,
    nominee: appFormData?.formWizard?.nomineeDetails,
    samultiple:
      quoteFormData?.ppt && calculatorFormData?.age
        ? calculateSAMultiple({
            PremiumPaymentTerm: quoteFormData?.ppt || 0,
            age: calculatorFormData?.age,
          })
        : 0,

    lead_type: currentPageStep != "appFormScreen" ? "Lead" : "Drop",
    calctype: suitabilityData?.calcType,
    selectedfunds: quoteFormData?.allocatedFunds ? getSelectedFunds(quoteFormData?.allocatedFunds) : 0,
    traiflag: calculatorFormData?.trai_flag,
    payout: LMS_CONSTANTS[quoteFormData?.payoutType] ?? "LumpSum",
    existing_cust: calculatorFormData?.employeeId || existingCustomer ? "Yes" : "No",
    invest_strat: suitabilityData?.invest_strat,
    fundcat: suitabilityData?.fundCat,
    h_mobile: CryptoJS.MD5(calculatorFormData?.mobileno).toString().toUpperCase(),
    h_email: CryptoJS.MD5(calculatorFormData?.emailid).toString().toUpperCase(),
    trai: calculatorFormData?.trai_flag,
    paymentoption: LMS_CONSTANTS[quoteFormData?.paymentOption],
    relation: suitabilityData?.relation,
    mode: suitabilityData?.mode,
    ppt: quoteFormData?.ppt,
    lifecover: quoteFormData?.lifeCover,
    step: `step${savingForm?.currentStep}`,
    whole_life: suitabilityData?.whole_life,
    adbr: suitabilityData?.adbr,
    mobileno: calculatorFormData?.mobileno,
    emailid: calculatorFormData?.emailid,
    pincode: calculatorFormData?.pincode,
    outputobjhold_4: suitabilityData?.OutputObjHold_4,
    outputobjhold_8: suitabilityData?.OutputObjHold_8,
    occupation: calculatorFormData?.calc_occupation,
    isEnglish: params?.lan === "hindi" ? "FALSE" : "TRUE",
    funds: suitabilityData?.funds,
    swp: suitabilityData?.swp,
    ats: suitabilityData?.ats,
    pan: appFormData?.panNumber,
    address: appFormData?.personalDetails?.full_address,
    productid: calculatorFormData?.productCode,
    uid: UID,
    appno: appFormData?.appNO,
    lifecover2: convertToWords(quoteFormData?.lifeCover), //check
    sumassured2: convertToWords(quoteFormData?.SA),
    pagename: appFormData?.ProductName, //check
    invest_type: suitabilityData?.invest_type,
    investvalue: quoteFormData?.investvalue,
    goals: suitabilityMatrix?.financialAndFamilyGoals,

    paymentOption: LMS_CONSTANTS[quoteFormData?.paymentOption],
    saMultiple:
      quoteFormData?.ppt && calculatorFormData?.age
        ? calculateSAMultiple({
            PremiumPaymentTerm: quoteFormData?.ppt || 0,
            age: calculatorFormData?.age,
          })
        : 0,

    lifeCover: quoteFormData?.lifeCover,
    traiFlag: calculatorFormData?.trai_flag,
    OutputObjHold_4: suitabilityData?.OutputObjHold_4,
    OutputObjHold_8: suitabilityData?.OutputObjHold_8,
    SavingsPercentage: suitabilityData?.pastPerformancePercent,
    Pincode: calculatorFormData?.pincode,
    LDUID: UID,
    timestamp: getCurrentTimeStamp(),
    PageName: appFormData?.ProductName,
    p_ender: calculatorFormData?.propGender,
    propAge: calculatorFormData?.propAge ? getAge(calculatorFormData?.propAge) : "",
    propDob: calculatorFormData?.propAge ?? "",
    propGender: calculatorFormData?.propGender,
    p_gender: calculatorFormData?.propGender,
    p_dob: calculatorFormData?.propAge,
    suitCheckbox: suitabilityData?.skip_suitability_check,
    isWhatsappOpted: quoteFormData?.wth_option ? "Yes" : "No",
    isAndroid: new URL(window.location.href).searchParams.get("device") === "android",
    isIos: new URL(window.location.href).searchParams.get("device") === "ios",

    isNRI: trueFalse(calculatorFormData.nri) ? OPTION_VALUES.TRUE_STRING : OPTION_VALUES.FALSE_STRING,
    lms_nri: calculatorFormData?.nri,
    Education: calculatorFormData?.calc_education,
    productId: calculatorFormData?.productCode,
    fundCat: suitabilityData?.fundCat,
    calcType: suitabilityData?.calcType,
    selectedFunds: quoteFormData?.allocatedFunds ? getSelectedFunds(quoteFormData?.allocatedFunds) : 0,
    isDefaultPastRequired: true,
    RiderOptionAdded: RiderOptionAdded,
    IsWOP: isWopSelected,
    WOP_SelctedOption: wopOption,
    rider1: quoteFormData?.selectedRiders?.[0],
    rider2: quoteFormData?.selectedRiders?.[1],
    rider3: quoteFormData?.selectedRiders?.[2],
    brochure_selected: "",
    Tollfree_selected: "",
    qdata: queryParams?.get("qdata") ?? "",
    UID: UID,
    p_age: calculatorFormData?.propAge ? getAge(calculatorFormData?.propAge) : "",
    TRAI_FLAG: calculatorFormData?.trai_flag ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,

    annual_prem: annualPremium,
    annualincome: calculatorFormData?.yr_income,
    city: calculatorFormData?.city,
    isandroid: new URL(window.location.href).searchParams.get("device") === "android",
    isios: new URL(window.location.href).searchParams.get("device") === "ios",
    isnri: trueFalse(calculatorFormData.nri) ? OPTION_VALUES.TRUE_STRING : OPTION_VALUES.FALSE_STRING,
    iswop: isWopSelected,
    lcbflag: "Base" || "LCB",
    lduid: UID,
    mbbenefityear: QuoteFormValues.getMoneyBackYear || "",
    mbpercentage: QuoteFormValues.getMoneyBackPct || "",
    modalpremium: QuoteFormValues.invest || "",
    optforrop: QuoteFormValues.wantMoneyback || "",
    payoutoption: LMS_CONSTANTS[quoteFormData?.payoutType],
    payoutterm: QuoteFormValues.incomeFor || "",
    pensionfrequency: QuoteFormValues.incomeForFrequency || "",
    propdob: calculatorFormData?.propAge ?? "",
    propgender: calculatorFormData?.propGender,
    rideroptionadded: RiderOptionAdded,
    specialdate: "",
    tollfree_selected: "",
    suitcheckbox: suitabilityData?.skip_suitability_check,
    whatsapp_flag: calculatorFormData?.trai_flag ? "Y" : "N",
    wop_selctedoption: wopOption,
    lname: "",
    fname: "",
    emp_id: calculatorFormData?.employeeId ?? "",
    employeeid: calculatorFormData?.employeeId ?? "",
    deathbenefitoption: QuoteFormValues.customiseIncome || "",
    defermentperiod: QuoteFormValues.ppt === 5 ? 3 : "",
    policyterm: quoteFormData?.term,

    channel: "",
    _epoch: "",
    _visid: "",
    checktwo: "",
    desiredlifecover: "",
    early_income: "",
    getincome: "",
    guaranteedcashbenefit: "",
    guaranteedcashbenefit2: "",
    guranteed_returns: "",
    income_date: "",
    income_frequency: "",
    incomemode: "",
    lduid_source: "",
    optformaturity: "",
    total_amount: "",
  };

  return { ...CommonKeys(calculatorFormData, existingCustomer, quoteFormData), ...giftProInput };
};

export default getGiftProUserInput;
